import loadable from '@loadable/component';

import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const CmsListingCountsLoadable = hydrateOnDemand(
  loadable(() => import('./CmsListingCounts'), {
    resolveComponent: (module) => module.CmsListingCounts,
  }),
);
